import i18n from 'i18next';

const allowedLocales = ['en-US', 'ru-RU'];

const localeKey = 'app@i18-locale';
let initialLocale = localStorage.getItem(localeKey);
if (!initialLocale || !allowedLocales.includes(initialLocale)) {
  initialLocale = 'en-US';
  localStorage.setItem(localeKey, initialLocale);
}

const options = {
  interpolation: {
    escapeValue: false,
  },
  debug: false,
  resources: {},
  fallbackLng: 'en-US',
  ns: ['common'],
  defaultNS: 'common',
  react: {
    wait: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default',
  },
};

const append = (locale, key, value) => {
  options.resources[locale] = options.resources[locale] || {};
  options.resources[locale].common = options.resources[locale].common || {};
  options.resources[locale].common[key] = value;
};

let dataFetched = false;
export async function fetchTranslations() {
  if (dataFetched) {
    return;
  }

  const messages = await import('./messages.json');
  Object.keys(messages).forEach((key) => {
    allowedLocales.forEach((locale) => {
      append(locale, key, messages[key][locale]);
    });
  });

  i18n.init(options);
  i18n.changeLanguage(initialLocale);

  dataFetched = true;
}

export default i18n;
